import { getMarketOverviewBreadcrumbsRoute } from '@/finsight/ui/common/helpers';

const getLoanLevelBreadcrumbs = () => ([
  getMarketOverviewBreadcrumbsRoute(),
  {
    title: 'Loan-Level Data (ABS-EE)',
    isActive: true,
  },
]);

export default getLoanLevelBreadcrumbs;
